import React, { useState, useEffect } from 'react';

import { callGetFeatureJson } from '../api/jsonFeatureApi';
import { FeatureLine } from '../components/SelectedFeature/FeatureLine';
import { FeaturePoint } from '../components/SelectedFeature/FeaturePoint';

export const FeaturePoi = ({feature, layer_id}) => {

  const [typeGeo, setTypeGeo] = useState(null);
  const [loadData, setLoadData] = useState(false);
  const [apiFeature, setApiFeature] = useState(null);

  useEffect(() => {
    setLoadData(true);
    if (layer_id === 'obstacles-layer') {
      setTypeGeo('Point');
      setApiFeature(feature);
    } else {
      callGetFeatureJson(layer_id, feature.properties.fid).then(
        result => {
          const {geometry} = result;
          setApiFeature(result);
          setTypeGeo(geometry.type);
        }
      ).catch(error => {
        console.log('error', error);
      });
    }
    setLoadData(false);
    return () => {
      setTypeGeo(null);
    };
  }, [feature]);

  const renderFeatureDetails = () => {
    return (
      <>
        { typeGeo.includes('LineString') && (
          <FeatureLine
            feature={apiFeature}
            layer_id={layer_id}
          />
        )}
        { typeGeo.includes('Point') && (
          <FeaturePoint
            feature={apiFeature}
            layer_id={layer_id}
          />
        )}
      </>
    );
  };

  return (
    <>
      {!loadData && typeGeo !== null && (renderFeatureDetails())}
    </>
  );
};